import { IApplicationState } from '../../types/redux';

export const genplanSeoPageActiveSelector = (state: IApplicationState): boolean => {
  return state.seoPages.isGenplanSeoPageActive;
};
